// reducers/index.js

import { combineReducers } from "redux";
import soundToggleReducer from "./ToggleSound";
import questionReducer from "./QuestionNumber";
import sutramasterReducer from "./SutraMaster";
import sutrapointsReducer from "./SutraPoints";

// Import the action type for setting the user's UID
import { SET_USER_UID } from "../actions";

/**
 * Reducer to handle the authenticated user's UID in Redux state.
 * Uses "if" statements for readability.
 *
 * @param {string|null} state - The current UID or null if not set.
 * @param {Object} action - The Redux action.
 * @returns {string|null} The updated UID or null.
 */
function userUidReducer(state = null, action) {
  if (action.type === SET_USER_UID) {
    return action.payload;
  }
  return state;
}

/**
 * Root reducer for the Redux store.
 * Combines all individual feature reducers into a single state object.
 *
 * State shape:
 * {
 *   soundToggle: boolean,
 *   questionNumber: number,
 *   sutraMaster: number,
 *   sutraPoints: number,
 *   userUid: string | null
 * }
 */
const rootReducer = combineReducers({
  soundToggle: soundToggleReducer, // Handles sound on/off state
  questionNumber: questionReducer, // Tracks the current question index
  sutraMaster: sutramasterReducer, // Tracks the current sutra index
  sutraPoints: sutrapointsReducer, // Tracks the user's sutra points
  userUid: userUidReducer, // Stores the authenticated user's UID
});

export default rootReducer;
